const RAPID_FIRE_FLOW_STORAGE_KEY = "rapid_fire_flow_state";

function toPositiveNumber(value, fallback = 0) {
  const nextValue = Number(value);
  return Number.isFinite(nextValue) && nextValue > 0 ? nextValue : fallback;
}

function cloneIfObject(value) {
  return value && typeof value === "object" ? { ...value } : null;
}

export function getStoredRapidFireFlowState() {
  if (typeof window === "undefined") {
    return {};
  }

  try {
    const rawValue = window.sessionStorage.getItem(RAPID_FIRE_FLOW_STORAGE_KEY);
    return rawValue ? JSON.parse(rawValue) : {};
  } catch (_error) {
    return {};
  }
}

export function buildRapidFireFlowState(routeState = {}, fallbackState = {}) {
  const mergedState = {
    ...fallbackState,
    ...routeState,
  };
  const stateId = toPositiveNumber(
    mergedState?.selectedState?.state_id ||
      mergedState?.state_id ||
      fallbackState?.selectedState?.state_id ||
      fallbackState?.state_id,
    13
  );
  const categoryId = toPositiveNumber(
    mergedState?.selectedCategory?.category_id ||
      mergedState?.category_id ||
      fallbackState?.selectedCategory?.category_id ||
      fallbackState?.category_id,
    5
  );
  const subjectId = toPositiveNumber(
    mergedState?.selectedSubject?.subject_id ||
      mergedState?.selectedSubject?.id ||
      mergedState?.subject_id ||
      fallbackState?.selectedSubject?.subject_id ||
      fallbackState?.selectedSubject?.id ||
      fallbackState?.subject_id,
    0
  );

  const selectedState = cloneIfObject(mergedState?.selectedState) || {
    state_id: stateId,
  };
  const selectedCategory = cloneIfObject(mergedState?.selectedCategory) || {
    category_id: categoryId,
  };
  const selectedSubject = cloneIfObject(mergedState?.selectedSubject);
  const selectedBatch = cloneIfObject(mergedState?.selectedBatch);
  const batchData = cloneIfObject(mergedState?.batchData);
  const rapidFireBackTarget = mergedState?.rapidFireBackTarget
    ? {
        pathname: mergedState.rapidFireBackTarget.pathname,
        state: cloneIfObject(mergedState.rapidFireBackTarget.state) || {},
      }
    : null;

  return {
    ...fallbackState,
    ...routeState,
    selectedState,
    selectedCategory,
    selectedSubject,
    selectedBatch,
    batchData,
    state_id: stateId,
    category_id: categoryId,
    subject_id: subjectId,
    rapidFireBackTarget,
  };
}

export function persistRapidFireFlowState(flowState) {
  if (typeof window === "undefined") {
    return;
  }

  try {
    window.sessionStorage.setItem(
      RAPID_FIRE_FLOW_STORAGE_KEY,
      JSON.stringify(flowState || {})
    );
  } catch (_error) {
    // Ignore storage failures and fall back to in-memory route state.
  }
}

export function buildRapidFireBackTarget(pathname, state = {}) {
  return {
    pathname,
    state: buildRapidFireFlowState({ ...state, rapidFireBackTarget: null }),
  };
}

export function buildRapidFireSubjectsState(flowState = {}) {
  const resolvedFlowState = buildRapidFireFlowState(flowState);

  return {
    ...resolvedFlowState,
    selectedState: resolvedFlowState.selectedState || {
      state_id: resolvedFlowState.state_id,
    },
    selectedCategory: resolvedFlowState.selectedCategory || {
      category_id: resolvedFlowState.category_id,
    },
    state_id: resolvedFlowState.state_id,
    category_id: resolvedFlowState.category_id,
  };
}
